class DomainProvider {
  // '~mathflat.com', '~schoolflat.com', '~mathflat.co.kr' 가 아닌 환경을 모두 local로 가정함(vercel, local 등)
  private _isLocalOrPreview =
    !/(^|\.)(mathflat|schoolflat)\.(com|co\.kr)$/.test(
      window.location.hostname
    );

  private readonly _DEFAULT_DOMAIN = "mathflat.com";
  readonly TARGET_DOMAIN: string;
  constructor() {
    this.TARGET_DOMAIN = this._setTargetDomain();
  }
  debugging({ isLiveEnv = false }: { isLiveEnv?: boolean } = {}) {
    if (!isLiveEnv) {
      if (typeof window !== "undefined") {
        (window as any).setCustomDomain = this._setLocalTargetDomain;
      }
      console.info("API target domain:", this.TARGET_DOMAIN);
    }
  }
  private _setTargetDomain() {
    try {
      if (this._isLocalOrPreview) {
        return localStorage.getItem("testDomain") || this._DEFAULT_DOMAIN;
      }

      const hostname = window.location.hostname;

      if (hostname.includes("schoolflat")) {
        return this._DEFAULT_DOMAIN;
      }

      // hostname에서 teacher-dev.~, teacher.~, student.~, pdf.~, ... 제거
      const prefix = hostname.split(".")[0] + ".";
      return hostname.replace(prefix, "") || this._DEFAULT_DOMAIN;
    } catch (e) {
      return this._DEFAULT_DOMAIN;
    }
  }

  private _setLocalTargetDomain(domain: string) {
    localStorage.setItem("testDomain", domain);
  }
}

export const domainProvider = new DomainProvider();
